export const insurancePolicy = [
  {
    header: "Host Members' Responsibility",
    answer:
      "As a Host Member, it is your duty to secure and maintain the proper insurance for your property during the Exchange. This includes homeowners, renters, or any other legally required insurance. The insurance must cover all aspects of the Exchange, including any equipment involved, and must remain valid for the entire duration of the Exchange period.",
  },
  {
    header: "Consequences of Failing to Maintain Insurance",
    answer:
      "If you do not keep your insurance active and up-to-date, HomeSwap reserves the right to cancel your account immediately. We may also ask you to provide proof of your insurance policy and other related information. Failure to respond to this request or providing inaccurate information could result in your account being suspended or terminated.",
  },
  {
    header: "Understanding Insurance Coverage",
    answer:
      "Each Member is expected to thoroughly review and understand their own insurance policy, as well as the insurance of the Member they are exchanging with. This includes knowing the scope of property and liability coverage provided.",
  },
  {
    header: "Responsibility for Policy Violations",
    answer:
      "If participating in an Exchange breaches any terms or conditions of your insurance policy, you are solely accountable for the consequences. HomeSwap is not liable for any conflicts or issues arising between you and your insurance provider due to your participation in the Exchange.",
  },
];
